import React from "react";
import style from "./ReportEvents.scss";

export default ({ data, playersInfo, staffInfo }) => {
    const isPenaltyGoal = [24, 25].includes(data?.postType);
    const playerId =
        data?.postType === 32 ? data?.shooterContact : data?.player;
    const playerInfo = playersInfo.find((player) => player?.id === playerId);

    const isStaff = staffInfo.find(
        (player) => player?.contact === data?.staffContact
    );

    const getEventElement = () => {
        if (data?.type === "Goals" || isPenaltyGoal) {
            return (
                <>
                    <div className={style["event__goals"]}>
                        <span>{data.homeGoals}</span>:
                        <span>{data.awayGoals}</span>
                    </div>
                    {data?.postType === 24 && (
                        <div className={style["event__name"]}>Goal</div>
                    )}
                    {data?.postType === 25 && (
                        <div className={style["event__name"]}>Miss</div>
                    )}
                </>
            );
        }
        if (data?.type === "Cards" || data?.type === "StaffCards") {
            return (
                <div className={style[`event__card-${data.postType}`]}></div>
            );
        }
        if (data?.postType === 32) {
            return <div className={style["event__name"]}>Penalty</div>;
        }
        return null;
    };

    const name =
        playerInfo && !isPenaltyGoal
            ? `${playerInfo.firstName}, ${playerInfo.lastName}`
            : isStaff
            ? isStaff.contactName
            : "";

    return (
        <div
            className={data ? style["event__card"] : null}
            style={!data ? { padding: "10px 30px" } : {}}
        >
            {data && (
                <>
                    {getEventElement()}
                    <div className={style["event__name"]}>{name}</div>
                    <span style={{ fontSize: "16px" }}>({data.minute}')</span>
                </>
            )}
        </div>
    );
};
